export enum CoveragePricingStrategy {
  Fixed = "fixed",
  CartTotal = "cart_total",
  ItemCount = "item_count",
}
